import React from 'react';

import "./ChatOnline.css"


const ChatOnline = () => {
    return (
        <div className="chatOnline">
            <img
                className="chatOnlineBadge"
                src="https://icons.veryicon.com/png/o/miscellaneous/8atour/success-35.png"
                alt="chatOnlineBadge"
            />
        </div>
    );
};

export default ChatOnline;